import React from 'react';


function FrameworkAlignment() {
  return (
    <>

      <div className="max-w-4xl mx-auto py-12 px-6">
        <h1 className="text-3xl font-bold text-[#102A43] mb-8 border-b border-gray-200 pb-4">Framework Alignment</h1>

        <div className="space-y-12">
          
          {/* Disclaimer */}
          <section className="bg-[#F9FAFB] p-6 border border-gray-200 text-sm text-[#64748B] mb-8 rounded-sm">
            <p><strong>Disclaimer:</strong> This mapping is provided for informational purposes to demonstrate conceptual alignment. AASC Standards are independent voluntary industry standards. Alignment with AASC standards does not imply endorsement by OECD, ISO, or any other body, nor does it guarantee compliance with their respective frameworks.</p>
          </section>

          {/* OECD Mapping */}
          <section>
            <h2 className="text-xl font-bold text-[#102A43] mb-6 uppercase tracking-wide">OECD AI Principles Mapping</h2>
            <div className="overflow-x-auto border border-gray-200 rounded-sm">
              <table className="w-full text-left text-sm">
                <thead className="bg-gray-100 text-[#102A43]">
                  <tr>
                    <th className="px-6 py-4 font-bold border-b border-gray-200">OECD Principle</th>
                    <th className="px-6 py-4 font-bold border-b border-gray-200">Related AASC Standard</th>
                    <th className="px-6 py-4 font-bold border-b border-gray-200">Operational Implementation</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200 bg-white">
                  <tr>
                    <td className="px-6 py-4 font-medium">1.1 Inclusive growth, sustainable development and well-being</td>
                    <td className="px-6 py-4 font-mono text-[#2F80ED]">AI-ROI-1.0</td>
                    <td className="px-6 py-4 text-gray-600">Defining clear responsibility domains to ensure intended beneficial outcomes.</td>
                  </tr>
                  <tr>
                    <td className="px-6 py-4 font-medium">1.2 Human-centred values and fairness</td>
                    <td className="px-6 py-4 font-mono text-[#2F80ED]">AI-ABND-1.0</td>
                    <td className="px-6 py-4 text-gray-600">Setting explicit boundaries to prevent harmful or unauthorized agent behavior.</td>
                  </tr>
                  <tr>
                    <td className="px-6 py-4 font-medium">1.3 Transparency and explainability</td>
                    <td className="px-6 py-4 font-mono text-[#2F80ED]">AI-DISC-1.0</td>
                    <td className="px-6 py-4 text-gray-600">Mandating clear client disclosure of agent capabilities and limitations.</td>
                  </tr>
                  <tr>
                    <td className="px-6 py-4 font-medium">1.4 Robustness, security and safety</td>
                    <td className="px-6 py-4 font-mono text-[#2F80ED]">AI-READ-1.0</td>
                    <td className="px-6 py-4 text-gray-600">Requiring incident response plans and readiness for failure modes.</td>
                  </tr>
                  <tr>
                    <td className="px-6 py-4 font-medium">1.5 Accountability</td>
                    <td className="px-6 py-4 font-mono text-[#2F80ED]">AI-ACCT-1.0<br/>AI-HITL-1.0</td>
                    <td className="px-6 py-4 text-gray-600">Mapping outputs to human liable parties and defining human authority triggers.</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          {/* ISO Concepts */}
          <section>
            <h2 className="text-xl font-bold text-[#102A43] mb-6 uppercase tracking-wide">ISO Management System Concepts</h2>
            <div className="grid md:grid-cols-2 gap-6">
              <div className="border border-gray-200 p-6 rounded-sm">
                <h3 className="font-bold text-[#102A43] mb-2">Plan-Do-Check-Act (PDCA)</h3>
                <p className="text-[#64748B] text-sm">
                  AASC <strong>AI-PERF-1.0</strong> (Performance Monitoring) implements the "Check" and "Act" phases by requiring continuous drift monitoring and change control logs, ensuring that AI operations remain within defined quality parameters over time.
                </p>
              </div>
              <div className="border border-gray-200 p-6 rounded-sm">
                <h3 className="font-bold text-[#102A43] mb-2">Risk-Based Thinking</h3>
                <p className="text-[#64748B] text-sm">
                  AASC <strong>AI-ABND-1.0</strong> (Accountability Boundaries) applies risk-based thinking by forcing the explicit definition of "Negative Scope"—identifying high-risk actions the system is prohibited from taking before deployment.
                </p>
              </div>
            </div>
          </section>

        </div>
      </div>
    </>
  );
}

export default FrameworkAlignment;